/* @flow */
export default {
  Small: '@media (min-width: 375px)',
  SmallCapped: '@media (min-width: 375px) and (max-width: 767px)',
  Medium: '@media (min-width: 768px)',
  MediumCapped: '@media (min-width: 768px) and (max-width: 1023px)',
  Large: '@media (min-width: 1024px)',
  LargeCapped: '@media (min-width: 1024px) and (max-width: 1199px)',
  XLarge: '@media (min-width: 1200px)',
  Retina: `@media (min--moz-device-pixel-ratio: 1.5),
    (-o-min-device-pixel-ratio: 3/2),
    (-webkit-min-device-pixel-ratio: 1.5),
    (min-device-pixel-ratio: 1.5),
    (min-resolution: 144dpi),
    (min-resolution: 1.5dppx)`,

  Tall: '@media (min-height: 820px)',
  InternetExplorer: '@media all and (-ms-high-contrast: none), (-ms-high-contrast: active)',

  js: (query: string) => {
    return query.replace(/@media\s/g, '');
  },
};



// WEBPACK FOOTER //
// ./src/ui/constants/MediaQueries.js